var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "multiplePrepend-box" }, [
    _c(
      "div",
      {
        class: [
          "input1 el-input el-input--mini el-input-group el-input-group--prepend",
          _vm.className,
        ],
      },
      [
        _c("div", { staticClass: "el-input-group__prepend" }, [
          _c("span", [
            _c("span", { staticClass: "error" }, [_vm._v("*")]),
            _vm._v(_vm._s(_vm.$t("dashboardCont.productkey"))),
          ]),
        ]),
        _c("multi-input-tag", {
          staticClass: "allNetKeyWord",
          class: { "is-disabled": _vm.disabled },
          attrs: {
            placeholder: _vm.$i18.language("请输入一个英文产品词"),
            disabled: _vm.disabled,
            id: `keyWord-input`,
            showSearchType: false,
            limit: 1,
          },
          on: {
            input: function ($event) {
              return _vm.loseBlur("key")
            },
          },
          model: {
            value: _vm.params.key,
            callback: function ($$v) {
              _vm.$set(_vm.params, "key", $$v)
            },
            expression: "params.key",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        class: [
          "input1 input2 el-input el-input--mini el-input-group el-input-group--prepend",
        ],
      },
      [
        _c("div", { staticClass: "el-input-group__prepend" }, [
          _c("span", [_vm._v(_vm._s(_vm.$i18.language("HS编码")))]),
        ]),
        _c("multi-input-tag", {
          staticClass: "allNetKeyWord",
          class: { "is-disabled": _vm.disabled },
          attrs: {
            minInputLength: 4,
            maxInputLength: 10,
            maxInputTips: _vm.$i18.language("最多输出十位HS编码!"),
            minInputTips: _vm.$i18.language("请输入至少四位HS编码!"),
            placeholder: _vm.$i18.language("至少4位，最多5个"),
            limitInputType: "1",
            id: `hscode-input`,
            disabled: _vm.disabled,
            showSearchType: false,
            limit: 5,
          },
          on: {
            input: function ($event) {
              return _vm.loseBlur("hscodes")
            },
          },
          model: {
            value: _vm.params.hscodes,
            callback: function ($$v) {
              _vm.$set(_vm.params, "hscodes", $$v)
            },
            expression: "params.hscodes",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "operation-box",
        class: { "is-disabled": _vm.disabled },
        on: {
          click: function ($event) {
            return _vm.operation(_vm.selectIndex)
          },
        },
      },
      [
        _c("i", {
          class: [
            { "el-icon-plus": _vm.isPlus, "el-icon-minus": !_vm.isPlus },
            "operation-icon",
          ],
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }